import { initAccessContext } from './walletAccessContext';
import { initWallet } from './wallet';
export { initWallet } from './wallet';
export { initAccessContext };
export var defaultAccessContext;
export function initDefaultAccessContext(options) {
    defaultAccessContext = initAccessContext(options);
    return defaultAccessContext;
}
var WAL = {
    initDefaultAccessContext: initDefaultAccessContext,
    get accessContext() {
        if (!defaultAccessContext) {
            throw new Error("\n        No default WalletAccessContext is configured. \n        Make sure to first run 'initDefaultAccessContext' to set it up.\n      ");
        }
        return defaultAccessContext;
    },
    initWallet: initWallet
};
export default WAL;
//# sourceMappingURL=index.js.map